export const LLableValue = ({ ...props }: LabelValueProps): JSX.Element => {
    return (
        <>
            <p className="is-6 has-text-primary">{props.label}</p>
            <p className="is-5 has-text-weight-bold no-wrap">{props.value}</p>
        </>
    );
};

interface LabelValueProps {
    label: string;
    value: string;
}
